import type { EditPlayerFormValues } from '../types'

/**
 * The form values to keep once a section save lands, so the form can stay open
 * (read mode) without waiting on the refetch:
 *
 * - the staged image is committed — it becomes the displayed `imageUrl`, and
 *   `imageData` / `imageDeleted` clear, so the next section's save does not
 *   upload or delete it again;
 * - every other value is kept as saved.
 */
export const toSavedFormBaseline = <T extends EditPlayerFormValues>(
  values: T
): T => ({
  ...values,
  imageUrl: values.imageData || (values.imageDeleted ? '' : values.imageUrl),
  imageData: '',
  imageDeleted: false,
})
